var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatasets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.5H22.5C23.3284 1.5 24 2.17157 24 3V21C24 21.8284 23.3284 22.5 22.5 22.5H1.5C0.671573 22.5 0 21.8284 0 21V3C0 2.17157 0.671573 1.5 1.5 1.5ZM22.5 3H1.5V21H22.5V3ZM21 6H3V7.5H21V6ZM3 9H10.5H21V19.5H3V9ZM4.5 10.5H9V12H4.5V10.5ZM9 13.5H4.5V15H9V13.5ZM4.5 18V16.5H9V18H4.5ZM10.5 18H19.5V16.5H10.5V18ZM19.5 15H10.5V13.5H19.5V15ZM10.5 12H19.5V10.5H10.5V12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasets);
export default __webpack_public_path__ + "static/media/datasets.812e5b14fa68f5bc1cce8effddc40524.svg";
export { ForwardRef as ReactComponent };